// import { useState } from "react";
import React,{useState} from "react";

export default function WeatherTemp(props) {
    const[unit,setUnit]=useState("celsius");

    function convertTofahrenheit(event) {
        event.preventDefault();
     setUnit("fahrenheit");  
    }

    function Showcelsius(event) {
        event.preventDefault();
        setUnit("celsius");
        
    }
    if (unit==="celsius") {
      return (
        <div className="weathertemp">
          <strong className="temp">{Math.round(props.celsius)}</strong>
          <span className="unit">
            °C |{""} <a href="/" onClick={convertTofahrenheit}>°F</a>
          </span>
        </div>
      );
    } else{
        let fahrenheit= (props.celsius *9 /5)+32;
        return (
          <div className="weathertemp">
            <strong className="temp">{Math.round(fahrenheit)}</strong>
            <span className="unit">
              <a href="/" onClick={Showcelsius}>
                °C
              </a>{""}
              °F|
            </span>
          </div>
        );
    }
}